import { DoughnutWithLegend } from "app/components/static-charts/doughnut-with-legend";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useMemo } from "react";

export const IndustryChart = ({ innerText }) => {
  const { t: trans } = useTranslation();

  const data = {
    labels: [
      trans("eCommerce"),
      trans("Professional Services"),
      trans("Food & Beverage"),
      trans("Sports & Fitness"),
      trans("Education & Training"),
      trans("Retail"),
    ],
    datasets: [
      {
        data: [40, 28, 9, 6, 7, 10],
        borderColor: "#00000000",
        backgroundColor: [
          "#7E57C5",
          "#E5FF00",
          "#1EFFFF",
          "#70FF64",
          "#7A7C84",
          "#FFFFFF",
        ],
      },
    ],
  };
  const options = useMemo(() => {
    return {
      cutout: "85%",
      responsive: true,
      elements: {
        center: {
          text: innerText,
          color: "#ffffff",
          fontStyle: "Montserrat",
          sidePadding: 30,
          minFontSize: 20,
          lineHeight: 25,
          innerRadius: 70,
          fontWeight: 600,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
      },
    };
  }, [innerText]);

  return (
    <DoughnutWithLegend
      data={data}
      options={options}
      textCss="text-white text-[13px] leading-[13px]"
      legendCss="ltr:md:ml-5 ml-0 pb-4 rtl:md:mr-5"
    />
  );
};

IndustryChart.propTypes = {
  innerText: PropTypes.string,
};
